import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { shouldForwardProp } from 'commons/utils/mui'
import { theme } from 'styles/theme/hav-theme'

type TabItemProps = {
  active: boolean
  disabled: boolean
}

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
`

export const TabsCol = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.neutral.white};
  padding: ${theme.spacing.xm};
  gap: ${theme.spacing.xs};
  border-radius: ${theme.shapes.borderRadius.md} 0 0 ${theme.shapes.borderRadius.md};
  border-right: 1px solid ${theme.colors.neutral[100]};
`

export const TabItem = styled('div', { shouldForwardProp })<TabItemProps>`
  display: flex;
  align-items: center;
  height: 35px;
  padding: 0 ${theme.spacing.md};
  border-radius: ${theme.shapes.borderRadius.sm};
  transition: background 0.2s ease-in-out;

  ${({ active, disabled }) => css`
    font-family: ${active ? theme.typography.family.bold : theme.typography.family.primary};
    background: ${active ? theme.colors.quartenary : theme.colors.neutral.white};
    font-weight: ${active ? theme.typography.weight.lg : theme.typography.weight.xsm};

    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    color: ${disabled ? theme.colors.neutral.mediumhover : theme.colors.neutral.high};

    p {
      user-select: ${disabled ? 'none' : 'auto'};
    }
    :hover {
      background: ${active ? theme.colors.quartenary : theme.colors.neutral[100]};
    }
  `}
`

export const TabTitle = styled.p`
  margin: 0;
  font-family: inherit;
  font-weight: inherit;
  white-space: nowrap;
  color: inherit;
  font-size: ${theme.typography.sizes.xs};
  line-height: ${theme.typography.lineHeight.md};
`
export const TabTotalizer = styled.span`
  margin-left: ${theme.spacing.xs};
  font-weight: ${theme.typography.weight.xsm};
  color: ${theme.colors.neutral.mediumhover};
  font-size: ${theme.typography.sizes.xs};
`

export const ContentContainer = styled.div`
  width: 100%;
  overflow: hidden;
  padding: ${theme.spacing.xm};
  background: ${theme.colors.neutral.white};
  border-radius: 0 ${theme.shapes.borderRadius.md} ${theme.shapes.borderRadius.md} 0;
`
